let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("AD9h4")).then(() => parcelRequire('43ajl'));